import { PrimaryButton, SecondaryButton } from 'src/shared/design-system/Buttons';
import { Chip } from 'src/shared/design-system/Chip';
import { Divider } from 'src/shared/design-system/Divider';
import { Modal, ModalBody, ModalFooter } from 'src/shared/design-system/Modal';
import { minScreen } from 'src/shared/utils/StyledComponentUtils';
import styled, { css } from 'styled-components';
import { ifProp } from 'web-common/src/shared/styled-utils/ifProp';
import { Border, Colors, Font, ScreenWidth, Spacing } from 'web-common/src/shared/styles';

// NOTE: Currently, the header is always 56px, as we refactor to support more verified dietary modals, this may need
// to be a little more dynamic
const HEADER_HEIGHT = 56;

export const DietaryDisclosuresModal = styled(Modal)`
  padding: 0;
  row-gap: 0;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: ${Spacing.SINGLE} ${Spacing.SINGLE} ${Spacing.SINGLE} ${Spacing.TRIPLE_HALF};
  position: relative;

  height: ${HEADER_HEIGHT}px;

  font-family: ${Font.Family.SANS};
  font-style: normal;
  font-weight: ${Font.Weight.NORMAL};
  font-size: ${Font.Size.M};
  line-height: 24px;
  color: ${Colors.GRAY_DARK_30};
`;

export const BackButtonContainer = styled.div`
  width: 48px;
  height: 100%;
  position: absolute;
  top: 0;
  left: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const BackButton = styled.div`
  border-radius: 100%;
  border: 2px solid ${Colors.GRAY_LITE_20};
  width: 24px;
  height: 24px;

  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

export const StyledModalBody = styled(ModalBody)`
  max-height: calc(100dvh - ${HEADER_HEIGHT}px);
`;

export const Section = styled.section<{ background?: string }>`
  display: flex;
  flex-direction: column;
  position: relative;
  padding: ${Spacing.SINGLE_HALF} ${Spacing.SINGLE};
  background: ${({ background }) => background ?? Colors.WHITE};
`;

export const StyledDivider = styled(Divider)`
  margin: unset;
`;

export const Title = styled.h2`
  font-family: ${Font.Family.SANS};
  font-style: normal;
  font-weight: ${Font.Weight.BOLD};
  font-size: ${Font.Size.M};
  color: ${Colors.GRAY_DARK_30};
  margin: unset;
  vertical-align: middle;
  padding-top: 5px;
`;

export const SectionTitle = styled.span`
  font-family: ${Font.Family.SANS};
  font-style: normal;
  font-weight: ${Font.Weight.BOLD};
  font-size: ${Font.Size.M};
  color: ${Colors.GRAY_DARK_30};
  vertical-align: middle;
`;

export const SectionText = styled.span`
  font-family: ${Font.Family.SANS};
  font-style: normal;
  font-weight: ${Font.Weight.MEDIUM};
  font-size: ${Font.Size.S};
  color: ${Colors.GRAY_DARK_15};
`;

export const SectionTextDarker = styled(SectionText)`
  color: ${Colors.GRAY_DARK_20};
`;

export const StyledChip = styled(Chip)<{ allAboveBaseline?: boolean }>`
  height: 32px;
  padding: ${Spacing.HALF};
  width: fit-content;
  font-weight: ${Font.Weight.SEMI_BOLD};

  // Keep text feeling balanced when no descenders
  ${ifProp(
    'allAboveBaseline',
    css`
      span {
        margin-top: 1px;
      }
    `
  )}
`;

export const StyledModalFooter = styled(ModalFooter)`
  padding: ${Spacing.SINGLE};
  border-top: 1px solid ${Colors.GRAY_LITE_20};
  box-shadow: 0px -6px 14px 0px rgba(0, 0, 0, 0.07);

  ${minScreen(ScreenWidth.SMALL)} {
    display: none;
  }
`;

export const QuestionsButton = styled(SecondaryButton)`
  padding: ${Spacing.HALF} ${Spacing.SINGLE};
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  align-self: stretch;
  justify-content: center;
  align-items: center;

  height: ${Spacing.TRIPLE};
  border: unset;
  border-radius: ${Border.Radius.M};

  font-size: ${Font.Size.S};
  font-style: normal;
  font-weight: ${Font.Weight.SEMI_BOLD};
  line-height: 130%;
  text-align: center;

  border: 1px solid ${Colors.GRAY_LITE_20};
`;

export const FooterButton = styled(PrimaryButton)`
  padding: ${Spacing.HALF} ${Spacing.SINGLE};
  display: flex;
  flex: 1 0 0;
  align-self: stretch;
  justify-content: center;
  align-items: center;

  height: ${Spacing.TRIPLE};
  border: unset;
  border-radius: ${Border.Radius.M};

  font-size: ${Font.Size.S};
  font-style: normal;
  font-weight: ${Font.Weight.SEMI_BOLD};
  line-height: 130%;
  text-align: center;
`;
